import React from 'react';

import Badge from '../Badge';

function EarlyAccessBadge() {
  return <Badge intent="success">Early access</Badge>;
}

export default EarlyAccessBadge;
